import React, { useCallback } from "react"
import { useHistory } from "react-router-dom"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { IconArrowLeftSmall } from "@izettle/otto"
import { IconButton } from "@izettle/react"

const BackButton = styled(IconButton).attrs(() => ({
  size: "small",
  variant: "minor",
  svgIcon: IconArrowLeftSmall,
  transform: { y: "-1px" },
}))`
  align-self: flex-start;
`

type CancelProps = {
  url: string
}

export const Cancel: React.FC<CancelProps> = ({ url }) => {
  const history = useHistory()
  const { text } = useLocalization()

  const onClick = useCallback(() => {
    if (url) {
      history.push(url)
    }
  }, [])

  return <BackButton onClick={onClick} title={text("BUTTON_BACK_TITLE")} />
}
